import intl from 'react-intl-universal'
import dayjs from 'dayjs'
import { formatJSON } from './index'

const DATE_FORMAT = 'YYYY-MM-DD'
const DEFAULT_ADVANCE_SECONDS = 0
const curDate = dayjs().format(DATE_FORMAT)

// 星期几映射
const dayMapping = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
};
// 生成时间间隔为30分钟的时间点
const generateTimeSlots = (startTime, endTime, needAll) => {
    const start = dayjs(startTime, 'HH:mm')
    const end = dayjs(endTime, 'HH:mm')

    const slots = []
    let current = start
    while (current.isBefore(end) || current.isSame(end, 'minute')) {
        slots.push(current.format('HH:mm'))
        current = current.add(30, 'minute')
    }

    return slots
}

const genMinuteArr = (start, end) => {
    const arr = []
    for (let i = start; i <= end; i++) {
        const label = i.toString().padStart(2, '0')
        arr.push({
            label,
            value: label
        })
    }
    return arr
}

// 计算最早可预订时间
const calculateEarliestBookingTime = (curTime, advanceDays, advanceHours, advanceMinutes) => {
    return curTime.add(advanceDays, 'day').add(advanceHours, 'hour').add(advanceMinutes, 'minute')
}

// 调整开始时间（如果早于最早可预订时间）
const adjustStartTimeIfNeeded = (date, hourStart, minuteStart, earliestBookingTime) => {
    const startDateTime = dayjs(`${date} ${hourStart}:${minuteStart}`)
    if (startDateTime.isBefore(earliestBookingTime)) {
        const adjusted = earliestBookingTime
        return {
            hourStart: adjusted.format('HH'),
            minuteStart: adjusted.format('mm')
        }
    }
    return { hourStart, minuteStart }
}

// 生成小时数组
const generateHourArray = (hourStart, hourEnd, minuteStart, minuteEnd, isCrossDay = false) => {
    const hourArr = []
    const startHour = parseInt(hourStart)
    const endHour = parseInt(hourEnd)
    const startMin = parseInt(minuteStart)
    const endMin = parseInt(minuteEnd)
    
    const maxHour = isCrossDay ? 23 : endHour
    for (let i = startHour; i <= maxHour; i++) {
        const label = i.toString().padStart(2, '0')
        let minStart = 0
        let minEnd = 59
        
        if (i === startHour) {
            minStart = startMin
        }
        if (i === endHour && !isCrossDay) {
            minEnd = endMin
            // 非跨天情况下，只有当结束分钟大于开始分钟时才添加最后一个小时
            if (endMin <= startMin) {
                continue
            }
        }
        
        hourArr.push({
            label,
            value: label,
            children: genMinuteArr(minStart, minEnd)
        })
    }
    
    return hourArr
}
export const calculateBookingTimes = (data, needAll = false) => {
    try {
        const { extendColumn } = data
        if (!extendColumn?.length) {
            return null
        }

        const config = formatJSON(extendColumn) || {}
        if (!Object.keys(config).length) {
            return null
        }

        const currentDate = new Date()
        let bookingDate = currentDate

        // 计算可预约天数
        const bookingDays = Math.max(1, parseInt(config.beginAdvanceDay || 1))
        // 计算预约日期
        if (config.endAdvanceDay > 0) {
            bookingDate = dayjs(currentDate).add(config.endAdvanceDay, 'day').toDate()
        }

        //生成预约日期
        let nDateArr = Array.from({ length: bookingDays }, (_, i) => {
            const date = dayjs(bookingDate).add(i, 'day').format(DATE_FORMAT)
            return date
        })

        const bookDateArr = []
        if ((config.bookTimeType === 1 || config.bookTimeType === 2) && config.bookDate && config.bookDate.length > 0) {
            config.bookDate.split(',').forEach((date, index) => {
                if (index < (bookingDays - 1)) {
                    const dateObj = dayjs(`${date} 23:59`).toDate()
                    if (dateObj >= bookingDate) {
                        bookDateArr.push(date)
                    }
                }
            })
            nDateArr = bookDateArr
        }

        // 计算提前预约时间（毫秒）- 同时考虑小时和分钟
        const advanceHours = config.endAdvanceHour > 0 ? Number(config.endAdvanceHour) : 0
        const advanceMinutes = config.endAdvanceMinute > 0 ? Number(config.endAdvanceMinute) : 0
        const advanceSeconds = (advanceHours > 0 || advanceMinutes > 0)
            ? (advanceHours * 60 * 60 * 1000) + (advanceMinutes * 60 * 1000)
            : DEFAULT_ADVANCE_SECONDS
        const advanceDays = config.endAdvanceDay > 0 ? Number(config.endAdvanceDay) : 0
        const advanceDaySeconds = advanceDays * 24 * 60 * 60 * 1000

        // BookTimeType 1原来默认时间类型，2新的时间类型
        const bookTimeType = config.bookTimeType || 1


        const dates = {}
        nDateArr.forEach(date => {
            // 如果该日期还没有初始化，才进行初始化，避免清空跨天时已添加的数据
            if (!dates[date]) {
                dates[date] = []
            }

            if (bookTimeType === 1) {
                let availableTimes = []
                if (config.selTimeType === 3) {
                    const arr = config.bookTime?.split('-')
                    const start = arr[0]
                    const end = arr[1]

                    let hourStart = start.split(':')[0]
                    const hourEnd = end.split(':')[0]
                    let minuteStart = start.split(':')[1] || '00'
                    const minuteEnd = end.split(':')[1] || '00'
                    const hourArr = []

                    // 是否跨天（需要转换为数字进行比较）
                    const isCrossDay = parseInt(hourStart) > parseInt(hourEnd)
                    const isToday = dayjs(date).isSame(dayjs(), 'day')
                    const curTime = dayjs()
                    const dateDayjs = dayjs(date)
                    const bookingDateDayjs = dayjs(bookingDate)

                    // 如果是当天，需要根据提前时间调整开始时间
                    if (isToday) {
                        const startDateTime = dayjs(`${date} ${start}`)
                        const diffTime = curTime.diff(startDateTime)
                        const advanceTime = advanceSeconds > 0 ? advanceSeconds : 1000 * 60 * 60
                        const shouldAdjustFromCurrent = diffTime > 0 || (diffTime < 0 && Math.abs(diffTime) < advanceTime)

                        if (shouldAdjustFromCurrent) {
                            const adjustedTime = curTime.add(advanceTime, 'millisecond')
                            hourStart = adjustedTime.format('HH')
                            minuteStart = adjustedTime.format('mm')
                        }
                    }

                    // 处理跨天和非跨天情况
                    const isFirstBookingDate = dateDayjs.isSame(bookingDateDayjs, 'day')
                    const earliestBookingTime = calculateEarliestBookingTime(curTime, advanceDays, advanceHours, advanceMinutes)
                    
                    if (isCrossDay) {
                        // 跨天情况：当天部分
                        if (isFirstBookingDate) {
                            const adjusted = adjustStartTimeIfNeeded(date, hourStart, minuteStart, earliestBookingTime)
                            hourStart = adjusted.hourStart
                            minuteStart = adjusted.minuteStart
                        }
                        
                        const todayHourArr = generateHourArray(hourStart, '23', minuteStart, '59', true)
                        hourArr.push(...todayHourArr)

                        // 第二天部分
                        const nextDate = dateDayjs.add(1, 'day').format(DATE_FORMAT)
                        const nextDateDayjs = dayjs(nextDate)
                        const isNextDayFirstBookingDate = nextDateDayjs.isSame(bookingDateDayjs, 'day')
                        
                        if (!dates[nextDate]) {
                            dates[nextDate] = []
                        }

                        let nextDayHourStart = '00'
                        let nextDayMinuteStart = '00'
                        
                        if (isNextDayFirstBookingDate && earliestBookingTime.isSame(nextDateDayjs, 'day')) {
                            nextDayHourStart = earliestBookingTime.format('HH')
                            nextDayMinuteStart = earliestBookingTime.format('mm')
                        }
                        
                        const nextDayHourArr = generateHourArray(nextDayHourStart, hourEnd, nextDayMinuteStart, minuteEnd)
                        
                        if (dates[nextDate].length === 0) {
                            dates[nextDate] = nextDayHourArr
                        } else {
                            dates[nextDate] = [...nextDayHourArr, ...dates[nextDate]]
                        }
                    } else {
                        // 非跨天情况
                        if (isFirstBookingDate) {
                            const adjusted = adjustStartTimeIfNeeded(date, hourStart, minuteStart, earliestBookingTime)
                            hourStart = adjusted.hourStart
                            minuteStart = adjusted.minuteStart
                        }

                        const normalHourArr = generateHourArray(hourStart, hourEnd, minuteStart, minuteEnd)
                        hourArr.push(...normalHourArr)
                    }

                    availableTimes = hourArr
                } else if (config.selTimeType === 2) {
                    availableTimes = []
                } else {
                    // 计算可用时间段
                    availableTimes = config.bookTime?.split(',')
                        .filter(time => {
                            const timeSlot = new Date(`${dayjs(date).format(DATE_FORMAT)} ${time}`)
                            return timeSlot - currentDate > (advanceDaySeconds + advanceSeconds)
                        }) || []
                }

                const currentDateTimes = config.selTimeType === 3 ?
                    availableTimes :
                    availableTimes.map(time => {
                        const hh = dayjs(`${date} ${time}`).format('hh:mm')
                        const ampm = dayjs(`${date} ${time}`).format('A')
                        return { label: `${hh}`, value: time, ampm }
                    })

                // 如果当前日期已有数据（跨天时前一天添加的凌晨数据），需要合并而不是覆盖
                dates[date] = dates[date].length > 0 ? [...dates[date], ...currentDateTimes] : currentDateTimes
            } else {
                const bookTimeRange = config.bookTimeRange || {}

                // 获取当前日期是周几
                const dayOfWeek = dayjs(date).format('dddd')
                const timeRanges = bookTimeRange[dayOfWeek] || []

                if (needAll) {
                    const currentDateTimes = timeRanges.map(item => ({ label: `${item.start}-${item.end}`, value: `${item.start}-${item.end}` }))
                    dates[date] = dates[date].length > 0 ? [...dates[date], ...currentDateTimes] : currentDateTimes
                } else {
                    // 生成所有可用时间点
                    const availableTimes = timeRanges.reduce((acc, range) => {
                        const timeSlots = generateTimeSlots(`${date} ${range.start}`, `${date} ${range.start}`, needAll)
                        return [...acc, ...timeSlots]
                    }, [])

                    // 过滤掉已经过去的时间
                    const filteredTimes = availableTimes.filter(time => {
                        const timeSlot = new Date(`${date} ${time}`)
                        return timeSlot - currentDate > (advanceDaySeconds + advanceSeconds)
                    })

                    const currentDateTimes = filteredTimes.map(time => {
                        const hh = dayjs(`${date} ${time}`).format('hh:mm')
                        const ampm = dayjs(`${date} ${time}`).format('A')
                        return { label: `${hh}`, value: time, ampm }
                    })

                    dates[date] = dates[date].length > 0 ? [...dates[date], ...currentDateTimes] : currentDateTimes
                }


            }

            return dates[date]
        })

        return {
            dates,
            advanceSeconds
        }
    } catch (err) {
        console.error(err, '////====err===')
        return null
    }
}

export const getBookingTimeStr = (data) => {
    const obj = calculateBookingTimes(data, true)
    if (!obj) return null
    let { dates } = obj
    const { extendColumn } = data
    const config = formatJSON(extendColumn)
    const { selTimeType = 1, bookTimeType = 1 } = config || {}
    //排除dates的value为空的时间
    dates = Object.fromEntries(Object.entries(dates).filter(([_, value]) => value.length > 0))
    const days = Object.keys(dates)
    if (days.length === 0) {
        return null
    }

    let times = dates[days[0]]
    const day = days.find(day => day === curDate)
    if (day) {
        times = dates[day]
    }

    let nDay = ''
    const arr = times?.map(item => item.value)
    //[10:00,10:30,11:00,11:30,12:00,12:30,13:00,13:30,14:00,14:30,15:00,15:30,16:00,16:30]
    //如果时间连续相隔30分钟或1小时，则显示arr[0]-arr[arr.length-1]

    if (arr.length > 1) {
        let start = arr[0]
        let end = arr[arr.length - 1]

        if (start.length === 2) {
            start = `${start}:00`
        }

        if (end.length === 2) {
            end = `${end}:59`
        }

        // 检查所有相邻时间点是否都是30分钟或1小时的间隔
        const isContinuous = arr.every((time, index) => {
            if (index === 0) return true
            const prevTime = dayjs(`${curDate} ${arr[index - 1]}`)
            const currentTime = dayjs(`${curDate} ${time}`)
            const diffMinutes = currentTime.diff(prevTime, 'minute')
            return diffMinutes === 30 || diffMinutes === 60
        })

        if (isContinuous) {
            // 如果不是当天的日期，需要显示完整日期
            if (day !== curDate) {
                nDay = days[0]

            }
            return {
                nDay: nDay ? dayjs(nDay).format('D MMMM') : '',
                timeStr: `${start}-${end} hrs`
            }
        }
    }
    // 如果不是连续时间，也需要判断是否显示日期
    if (day !== curDate) {
        nDay = days[0]
    }
    return {
        nDay: nDay ? dayjs(nDay).format('D MMMM') : '',
        timeStr: selTimeType === 3 ? config.bookTime : arr.join(', ')
    }
}

// 是否需要填写电子签名、用餐人数、订单备注
export const shouldGoNext = (data) => {
    const { extendColumn } = data
    if (!extendColumn?.length) {
        return false
    }
    const extData = formatJSON(extendColumn)
    const { electronicSignature = false, peopleSetType = 1, isOpenOrderRemark = false } = extData || {}
    return electronicSignature || peopleSetType === 2 || isOpenOrderRemark
}

// 是否在营业时间
export const isInOpenTime = ({ range, status, opening, outOfBusinessMessage }) => {
    // 如果商家不在营业状态，返回相应的提示信息
    if ((status === 1 && !opening) || status === 2 || status === 3) {
        let message = '';

        if (status === 1 && !opening) {
            // 获取当前星期几
            const currentDate = new Date();
            const dayOfWeek = currentDate.getDay();

            // 星期几映射
            // const dayMapping = {
            //     0: 'Sunday',
            //     1: 'Monday',
            //     2: 'Tuesday',
            //     3: 'Wednesday',
            //     4: 'Thursday',
            //     5: 'Friday',
            //     6: 'Saturday'
            // };

            const currentDayKey = dayMapping[dayOfWeek];

            // 解析营业时间范围
            let businessHoursText = '';
            if (range && range !== '') {
                try {
                    const businessHours = formatJSON(range);

                    if (businessHours[currentDayKey]) {
                        if (businessHours[currentDayKey].length > 0) {
                            businessHoursText = businessHours[currentDayKey]
                                .map((timeRange, index) => {
                                    const timeText = `${timeRange.start} - ${timeRange.end}`;
                                    return index === 0 ? timeText : `, ${timeText}`;
                                })
                                .join('');
                        } else {
                            businessHoursText = '00:00 - 24:00';
                        }
                    } else if (businessHours['All']) {
                        businessHoursText = businessHours['All']
                            .map((timeRange, index) => {
                                const timeText = `${timeRange.start} - ${timeRange.end}`;
                                return index === 0 ? timeText : `, ${timeText}`;
                            })
                            .join('');
                    }
                } catch (error) {
                    console.error('解析营业时间失败:', error);
                }
            }

            // 构建提示信息
            const getServiceTimeMessage = (businessHours) => {
                if (!businessHours) return null;
                return intl.get('out_of_service_time_tips', {
                    serviceTime: businessHours
                }).d(`服务时间为 ${businessHours}，非服务时间内不接受预订。`);
            };

            // 获取最终显示的消息
            message = outOfBusinessMessage || getServiceTimeMessage(businessHoursText) || ''
            // message = [
            //     outOfBusinessMessage,
            //     getServiceTimeMessage(businessHoursText)
            // ].filter(Boolean).join('<br/>')  // 过滤掉空值并用<br/>连接

            // 如果没有任何消息，使用默认提示
            if (!message) {
                message = intl.get('outOfTimeTips1').d('该时段不在营业时间内，无法点餐');
            }

        } else if (status === 2) {
            message = intl.get('outOfTimeTips2').d('商家休息中，暂不接单');
        } else if (status === 3) {
            message = intl.get('equity_stop_cooperating').d('Out of service');
        }

        return {
            openState: false,
            message
        }
    }

    return {
        openState: true,
        message: ''
    };
}

export const isInSellingTime = (rangeStr, rangeJSON) => {
    // 如果range为空或未定义，返回true

    if (!rangeStr || !rangeJSON) return { state: true, message: '' }

    // if (!rangeJSON) return true
    let message = intl.get('product_not_in_selling_time').d('当前产品不在销售时间内')
    if (rangeJSON) {
        const currentDate = new Date();
        const dayOfWeek = currentDate.getDay();
        const currentDayKey = dayMapping[dayOfWeek];
        const businessHours = rangeJSON[currentDayKey]
        let serviceTime = ''
        if (businessHours?.length > 0) {
            serviceTime = businessHours
                .map((timeRange, index) => {
                    const timeText = `${timeRange.start} - ${timeRange.end}`;
                    return index === 0 ? timeText : `, ${timeText}`;
                })
                .join('');
            message = intl.get('out_of_service_time_tips', {
                serviceTime: serviceTime
            }).d(`服务时间为 ${serviceTime}，非服务时间内不接受预订。`)
        }

    }
    return { state: false, message }; //只须判断rangeJSON有值，就返回false

    /*
    const rangeData = rangeJSON
    // range = { "Monday": [{ "start": "00:00", "end": "23:59" }], "Tuesday": [{ "start": "15:00", "end": "23:59" }], "Wednesday": [{ "start": "10:00", "end": "23:59" }], "Thursday": [{ "start": "00:00", "end": "23:59" }], "Friday": [{ "start": "00:00", "end": "23:59" }], "Saturday": [{ "start": "00:00", "end": "23:59" }], "Sunday": [{ "start": "00:00", "end": "23:59" }] }

    //当前时间是否在range中
    // 获取当前时间
    const now = new Date();
    const currentDay = now.getDay(); // 0-6 (周日-周六)

    // 星期几映射
    const dayMapping = {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
    };

    const currentDayKey = dayMapping[currentDay];

    // 获取当前时间字符串 (HH:MM格式)
    const currentTimeString = now.toTimeString().slice(0, 5);

    // 检查当前星期几是否在range中
    if (!rangeData[currentDayKey] || !Array.isArray(rangeData[currentDayKey])) {
        return false;
    }

    // 检查当前时间是否在任何一个时间区间内
    for (const timeRange of rangeData[currentDayKey]) {
        const { start, end } = timeRange;

        // 如果开始时间小于等于结束时间（同一天内）
        if (start <= end) {
            if (currentTimeString >= start && currentTimeString <= end) {
                return true;
            }
        } else {
            // 如果开始时间大于结束时间（跨天，比如23:00-06:00）
            if (currentTimeString >= start || currentTimeString <= end) {
                return true;
            }
        }
    }

    return false;

    */


}